// extracted by mini-css-extract-plugin
export default {"validationError":"validation-error-component__validation-error__TgD7m","icon":"validation-error-component__icon__JsVW4"};